import { useMemo } from 'react';
import { HStack } from '@direct-frontend/components';
import { getRequestContext } from '@/shared/lib/requestContext';
import { type PickupFilterKeys } from '../../lib';
import { usePickupAddressContext } from '../../PickupAddressContext';
import { PickupAddressFiltersButton } from '../PickupAddressFiltersButton';

type PickupFilters = Array<{ value: PickupFilterKeys; title: string; isShow: boolean }>;

export const PickupAddressFilters = () => {
    const { pickupFilters, changePickupFilters } = usePickupAddressContext();

    const {
        delivery: { disableOnlinePayment, disablePostPayment },
    } = getRequestContext();

    const filters = useMemo(() => {
        const filters: PickupFilters = [
            { value: 'hasFittingRoom', title: 'С примеркой', isShow: true },
            {
                value: 'hasPaymentOnDelivery',
                title: 'Оплата при получении',
                isShow: !disableOnlinePayment && !disablePostPayment,
            },
        ];

        return filters.filter((filter) => filter.isShow);
    }, [disableOnlinePayment, disablePostPayment]);

    if (filters.length === 0) {
        return null;
    }

    return (
        <HStack gap="8">
            {filters.map(({ value, title }) => (
                <PickupAddressFiltersButton
                    key={value}
                    isChecked={Boolean(pickupFilters[value])}
                    onClick={() => changePickupFilters(value, !pickupFilters[value])}
                >
                    {title}
                </PickupAddressFiltersButton>
            ))}
        </HStack>
    );
};
